import { type Html, UnsafeHtml, html, rune, View } from 'rune-ts';
import klass from './BenefitSection.module.scss';
import { getResizedUrl } from '../../../../../shared/util/image';
import { font } from '../../../../../shared/typography';

export interface BenefitCardProps {
  image_url: string;
  title: string;
  desc: Html | string | UnsafeHtml;
}

export class BenefitCard extends View<BenefitCardProps> {
  override template({ image_url, title, desc }: BenefitCardProps): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    return html`
      <div class="${klass.benefit_item} ${is_mobile ? 'swiper-slide' : ''}">
        <div class="${klass.img_wrapper}">
          <img
            src="${getResizedUrl({
              url: image_url,
              width: 400 * 2,
              quality: 85,
              format: 'webp',
            })}"
            alt="혜택 이미지"
          />
        </div>
        <div class="${klass.benefit_item_content}">
          <div class="${font('28_bold', '20_bold')}">${title}</div>
          <div class="${klass.desc} ${font('20_regular', '16_medium')}">${desc}</div>
        </div>
      </div>
    `;
  }
}
